/*
 * @Author: ze.wang@diact.com
 * @Date: 2022-06-28 15:36:00
 * @Function: Please Input Function
 */
export const SAVE_CONFIG = 'SAVE_CONFIG'
export const QUERY_QUESTIONLIST = 'QUERY_QUESTIONLIST'
export const INIT_CACHE_URL_PARAM = 'INIT_CACHE_URL_PARAM'
export const SYNC_REQ_PARAM = 'SYNC_REQ_PARAM'
export const GET_QUESTIONLIST = 'GET_QUESTIONLIST'
export const QUERY_ANSWERLIST = 'QUERY_ANSWERLIST'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const INIT_LANG_MAP = 'INIT_LANG_MAP'
export const GET_STYLE = 'GET_STYLE'
export const SYNC_STYLE = 'SYNC_STYLE'
export const SYNC_SURVEY_INFO = 'SYNC_SURVEY_INFO'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SYNC_USER_INFO = 'SYNC_USER_INFO'
export const QUERY_GROUPLIST = 'QUERY_GROUPLIST'
export const SYNC_GROUP = 'SYNC_GROUP'
export const SET_INIT_STATUS = 'SET_INIT_STATUS'
export const SET_ANSWER_STATUS = 'SET_ANSWER_STATUS'
export const SET_IS_COMPLETE = 'SET_IS_COMPLETE'
export const SET_CRT_EDIT_QU = 'SET_CRT_EDIT_QU'
export const SET_CRT_CLICK_QU = 'SET_CRT_CLICK_QU'
export const GET_SETTING = 'GET_SETTING' // 获取问卷设置
export const SYNC_SETTING = 'SYNC_SETTING'
export const BOT_SETTING = 'BOT_SETTING'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js